import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AutocompleteFieldComponent } from '../autocomplete-field.component';

@Component({
  selector: 'fr8bot-ui-autocomplete-item',
  templateUrl: './autocomplete-item.component.html',
  styleUrl: './autocomplete-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteItemUIComponent<ValueType, ItemType> {
  readonly value = input.required<ValueType>();
  readonly item = input<ItemType | null>(null);
  readonly disabled = input(false);

  private readonly autocompleteContainer = inject<AutocompleteFieldComponent<ValueType, ItemType>>(
    AutocompleteFieldComponent,
  );

  public onItemClick(): void {
    if (this.disabled()) return;

    const value = this.value();
    if (value) {
      this.autocompleteContainer.selectValue(value);
    }

    const item = this.item();
    if (item) {
      this.autocompleteContainer.selectItem(item);
    }
  }
}
